import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {DataService} from '../../data/data.ts';
import { ToastController } from 'ionic-angular';
import * as firebase from 'firebase';

@Component({
  templateUrl: 'build/pages/host/host.html'
})
export class HostPage {
  private dataService: DataService;
  public callback : Function;

  constructor(private navCtrl: NavController, private toastController : ToastController, private _data: DataService) {
  	this.dataService = _data;
  	this.callback = (error) => {
      if (error) {
        this.createToastWithMessage("Funds failed to transfer :( Try again.");
      } else {
        this.createToastWithMessage("Funds were transferred succesfully!");
      }
    }
  }

  ionViewLoaded() {
  }

  prevStage(){
  	this.dataService.moveStage(this.dataService.stageDirectionEnum.Backward);
  }

  nextStage(){
  	this.dataService.moveStage(this.dataService.stageDirectionEnum.Forward);
  }

  createToastWithMessage(message){
    let toast = this.toastController.create({
      message: message,
      duration: 3000,
      position: 'middle'
    });
    toast.present();
  }
}
